import * as UI from "@iyk/ui"

import { Profile } from "../profile.ts"
import { AttributesList } from "./attributes-list.tsx"
import { Sheet } from "./sheet.tsx"

export const MerchDetailSheet = ({ merch, onBuyNowClick }: MerchDetailSheet.Props) => {
  return (
    <Sheet.Root>
      <Sheet.Trigger asChild>
        <button type="button" className={UI.classForLink({ className: "w-fit" })}>
          Detalles
        </button>
      </Sheet.Trigger>
      <Sheet.Content title={merch.name} description={merch.title}>
        <div className="flex flex-col gap-4 px-4 pt-10 pb-6">
          <div className="flex flex-col gap-2">
            <UI.Icon.Badge />
            <span>{merch.name}</span>
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-xs-upper">Descripción</span>
            <span className="text-sm">{merch.description}</span>
          </div>
          <AttributesList attributes={merch.attributes} />
          {merch.buyLink && (
            <a
              href={merch.buyLink}
              onClick={onBuyNowClick}
              target="_blank"
              className={UI.classForButton({
                kind: "shaded",
                size: "lg",
                className: "w-full mt-4"
              })}
            >
              Comprar
              <UI.Icon.ArrowUpRight />
            </a>
          )}
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}

namespace MerchDetailSheet {
  export type Props = {
    merch: Profile.Merch
    onBuyNowClick: () => void
  }
}
